module.exports = __webpack_public_path__ + "media/images/carousel/metier-image-3-af4b608b0d42b05973b562c1497b0213.jpg";